import { render, staticRenderFns } from "./ActivityOwners.vue?vue&type=template&id=2575f72c&"
import script from "./ActivityOwners.vue?vue&type=script&lang=js&"
export * from "./ActivityOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports